import styled from 'styled-components'

import { colors } from '@crimeos-frontend/shared/style-guide'

import { getInputFieldLabelColor } from '../../../utils/getInputLabelColor'

export const LabelContainer = styled.span<{ css?: string }>`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.4px;
  color: ${(props: any) =>
    getInputFieldLabelColor({
      status: props.status,
      fontColors: props.inputFieldStyles
    })};
  @media (max-width: 768px) {
    max-width: 100%;
  }

  ${props => props.css}
`

export const OtpInputContainer = styled.div<{ css?: string }>`
  width: 100%;
  margin-top: 24px;
  margin-bottom: 8px;
  .otp-input-container {
    width: 38px;
    max-width: 48px;
    flex: 1;
    border-radius: 8px;
    margin-right: 12px !important;
    border: 1px solid ${colors['blue-gray-500']};
    color: ${colors['blue-gray-500']};
    font-size: 16px;
  }
  .otp-input-container:last-child {
    margin-right: 0px !important;
  }
  .otp-input-focus-style {
    border: 1px solid ${colors['blue-700']} !important;
    outline: none;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  }
  .otp-input-error-style {
    border: 1px solid ${colors['red-600']};
    color: ${colors['red-600']};
  }
  @supports (aspect-ratio: 1 / 1) {
    input {
      aspect-ratio: 1 / 1;
    }
  }

  ${props => props.css}
`
export const OTPFieldLabel = styled(LabelContainer)`
  font-size: 14px;
  margin-bottom: 12px;
  color: ${colors['blue-gray-700']};
  ${(props: { css?: string }) => props.css}
`

export const ErrorMessage = styled('p')<{ css?: string }>`
  font-weight: 500;
  min-height: 16px;
  font-size: 12px;
  margin-top: 4px;
  color: ${colors['red-600']};
  ${props => props.css};
  max-width: 100%;
  animation-name: slide-down;
  animation-duration: 200ms;

  @keyframes slide-down {
    0% {
      max-height: 0px;
      opacity: 0;
    }
    100% {
      max-height: 32px;
      opacity: 1;
    }
  }
`
